import { validateDateNotInFuture } from '../../utils/validators';

const buildAdditionalInformationSection = ({
  propertyState,
  applicantData,
}) => {
  return {
    name: 'additionalInformation',
    title: 'Additional Information',
    container: 'default',
    GridProps: { xs: 12 },
    fields: [
      ...(applicantData?.isProspect
        ? [
            {
              name: 'communications',
              title: 'COMMUNICATIONS',
              titleVariant: 'subsection',
              container: 'default',
              divider: true,
              fields: [
                {
                  variant: 'singleSelect',
                  name: 'howDidYouHearAboutProperty',
                  label: 'How did you hear about our property?',
                  placeholder: 'Select',
                  GridProps: { xs: 12, sm: 6, paddingLeft: 0 },
                },
              ],
            },
          ]
        : []),
      {
        name: 'criminalHistory',
        title: 'CRIMINAL HISTORY',
        titleVariant: 'subsection',
        divider: true,
        container: 'default',
        hidden: propertyState === 'US-WA',
        fields: [
          {
            variant: 'radioGroup',
            name: 'hasBeenConvictedOfFelony',
            label: 'Have you ever been convicted of a felony?',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            rules: {
              required: true,
            },
            sx: {
              flexDirection: 'row',
            },
            GridProps: { xs: 12, paddingLeft: 0 },
          },
        ],
      },
      {
        name: 'bankruptcy',
        title: 'BANKRUPTCY',
        titleVariant: 'subsection',
        container: 'default',
        divider: true,
        hidden: !applicantData.isFinanciallyResponsible,
        fields: [
          {
            variant: 'radioGroup',
            name: 'hasFiledBankruptcy',
            label:
              'Have you ever filed bankruptcy or are you currently involved in a bankruptcy case?',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            rules: {
              required: true,
            },
            sx: {
              flexDirection: 'row',
            },
            GridProps: { xs: 12, sm: 6, paddingLeft: 0 },
          },
          {
            variant: 'radioGroup',
            name: 'hasBankruptcyBeenDischarged',
            label: 'Has the bankruptcy been discharged?',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            sx: {
              flexDirection: 'row',
            },
            watchFields: ['hasFiledBankruptcy'],
            hidden: ({ getValues }) =>
              getValues('hasFiledBankruptcy') !== 'yes',
            rules: {
              required: ({ getValues }) =>
                getValues('hasFiledBankruptcy') === 'yes',
            },
            GridProps: { xs: 12, sm: 6, paddingLeft: 0 },
          },
          {
            variant: 'text',
            name: 'bankruptcyTypeFiled',
            label: 'Type Filed',
            watchFields: ['hasFiledBankruptcy'],
            hidden: ({ getValues }) =>
              getValues('hasFiledBankruptcy') !== 'yes',
            rules: {
              required: ({ getValues }) =>
                getValues('hasFiledBankruptcy') === 'yes',
            },
            GridProps: { xs: 12, sm: 6, paddingLeft: 0 },
          },
          {
            variant: 'date',
            name: 'bankruptcyDateFiled',
            label: 'Date filed',
            placeholder: 'MM/DD/YYYY',
            watchFields: ['hasFiledBankruptcy'],
            hidden: ({ getValues }) =>
              getValues('hasFiledBankruptcy') !== 'yes',
            rules: {
              required: ({ getValues }) =>
                getValues('hasFiledBankruptcy') === 'yes',
              validate: (value) => {
                return validateDateNotInFuture(value, 'Date filed');
              },
            },
            GridProps: { xs: 12, sm: 6, paddingLeft: 0 },
          },
        ],
      },
    ],
  };
};

export default buildAdditionalInformationSection;
